import { z } from 'zod';

export const CLIENT_TRANSACTIONS_FILTER_FORM_PROCESS_STATES = [
	'active',
	'cancelled',
] as const;

export type FilterClientTransactionProcessStatusKeys =
	(typeof CLIENT_TRANSACTIONS_FILTER_FORM_PROCESS_STATES)[number];

export const clientTransactionsFilterFormSchema = z.object({
	processStatus: z
		.enum(CLIENT_TRANSACTIONS_FILTER_FORM_PROCESS_STATES)
		.prefault('active'),
});

export type ClientTransactionsFilterForm = z.infer<
	typeof clientTransactionsFilterFormSchema
>;
